import { useEffect } from "react";
import { BrowserRouter as Router, useLocation, useRoutes } from "react-router-dom";
import {
  InvestmentPage,
  AboutUs,
  ContactUs,
  InvestmentDetail,
  InvestmentForm,
  Privacy,
  Testimonials,
  LoanPage,
  SolarFinancingPage,
  TermsAndCondition,
  BankVoleFAQs,
  Page404,
  IMS
  //TermsAndCondition
} from "./pages";
import WhistleblowingStatement from "./pages/whistleblower";
import BankvolePage from "./pages/bankvole-page";
import IMSPolicy from "./components/ims-policy";
import BankvoleLoanTerm from "./pages/bankvole-loan-term";



const pageTitles = {
  "/": "Checkoff Finance | Wealth Management",
  "/home": "Checkoff Finance | Wealth Management",
  "/wealth-management": "Build wealth with Checkoff Finance | Checkoff Finance Company Limited",
  "/solar-financing": "Get Solar Financing of up to ₦100M | Checkoff Finance",
  "/loans": "Checkoff Finance | Loans",
  "/about-us": "Checkoff Finance | About Us",
  "/contact-us": "Checkoff Finance | Contact Us",
  "/investment-detail": "Checkoff Finance | Investment Details",
  "/application-form": "Checkoff Finance | Investment Application",

  // legal Pages
  "/legal": "Checkoff Finance | Privacy Policy",
  "/legal/privacy-policy": "Checkoff Finance | Privacy Policy",
  "/legal/ims-policy": "Checkoff Finance | IMS Policy",
  "/legal/bankvole-loan-terms": "Checkoff Finance | Bankvole Loan Terms",
  "/legal/whistleblower": "Checkoff Finance | Whistleblower Statement",
  "/terms-and-condition": "Checkoff Finance | Terms and Conditions",


  "/testimonials": "Checkoff Finance | Testimonials",
  "/bankvole-faqs": "Checkoff Finance | Bankvole FAQs",
  "/bankvole": "Bankvole by Checkoff Finance",
};

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = pageTitles[pathname] || "Page Not Found | Checkoff Finance";
  }, [pathname]);

  return null;
};

const App = () => {
  return useRoutes([
    { path: "/", element: <InvestmentPage /> },
    { path: "/home", element: <InvestmentPage /> },
    // { path: "/", element: <HomePage /> },
    { path: "/wealth-management", element: <InvestmentPage /> },
    { path: "/solar-financing", element: <SolarFinancingPage /> },
    { path: "/loans", element: <LoanPage /> },
    { path: "/about-us", element: <AboutUs /> },
    { path: "/contact-us", element: <ContactUs /> },
    { path: "/investment-detail", element: <InvestmentDetail /> },
    { path: "/application-form", element: <InvestmentForm /> },

    // legal Pages
    { path: "/legal", element: <Privacy /> },
    { path: "/legal/privacy-policy", element: <Privacy /> },
    { path: "/legal/ims-policy", element: <IMS /> },
    { path: "/legal/bankvole-loan-terms", element: <BankvoleLoanTerm /> },
    { path: "/legal/whistleblower", element: <WhistleblowingStatement /> },
    { path: "/legal/terms-and-condition", element: <TermsAndCondition /> },


    { path: "testimonials", element: <Testimonials /> },
    { path: "/bankvole-faqs", element: <BankVoleFAQs /> },
    { path: "/bankvole", element: <BankvolePage /> },

    { path: "*", element: <Page404 /> },
  ]);
};
const AppWrapper = () => {
  return (
    <Router>
      <PageTitle />
      <App />
    </Router>
  );
};

export default AppWrapper;
